import Loader from '@/components/loader';
import NoneChip from '@/components/chip/none-chip';
import PolicyUsageCard from '@/components/policy-usage-card';
import useQueryHelper from '@/hooks/use-query-helper';
import { getServiceUsage } from '@/lib/services/public-service.service';
import { QueryKey } from '@/lib/query-client';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { useQuery } from 'react-query';

interface Props {
  publicServiceId: string;
}

const PublicServiceUsage: FC<Props> = ({ publicServiceId }) => {
  const query = useQuery(
    [QueryKey.PublicServiceView, publicServiceId, 'usage'],
    async () => getServiceUsage(publicServiceId),
    {
      enabled: !!publicServiceId,
    }
  );

  const { data: usage } = query;
  const { showLoader } = useQueryHelper(query);

  if (showLoader) {
    return <Loader />;
  }

  if (!usage?.inUse) {
    return <NoneChip />;
  }

  const { policies } = usage;

  return (
    <Stack gap={2}>
      <PolicyUsageCard
        policies={policies}
        policyLinkTab="service-access"
        policyLinkScrollId="allowed-services"
      />
    </Stack>
  );
};

export default PublicServiceUsage;
